import { STALE_TIME } from 'business/constants';
import { camelize } from 'helpers/syntaxHelper';
import React, { ReactNode } from 'react';
import { useQuery } from '@tanstack/react-query';
import { SecondaryBudgetAxisSourceTableContext } from 'routes/BudgetModule/components/BudgetWithProvider/SecondaryBudgetAxisSourceTableContext';
import { createBudgetQueryKeys } from 'routes/BudgetModule/helpers/createBudgetQueryKeys';
import { SecondaryBudgetAxisSources } from 'routes/Support/components/ClientSupport/components/BudgetConfiguration/types';
import { RQAPICallWithData } from 'store/APIClient';

export const FALLBACK_SECONDARY_BUDGET_AXIS_DISPLAY = 'axe secondaire';

const { secondaryBudgetAxisSourceKeys } = createBudgetQueryKeys();
const reactQueryKey = secondaryBudgetAxisSourceKeys();

const useGetSecondaryBudgetAxisSourceTable = () => {
    return useQuery<SecondaryBudgetAxisSources>({
        queryKey: reactQueryKey,
        queryFn: async () => {
            const response = await RQAPICallWithData<{
                secondaryBudgetAxisSourceTable: SecondaryBudgetAxisSources;
            }>({
                endpoint: `budget/operation/source_table`,
                method: 'GET',
            });

            return camelize(
                response.content.data?.secondaryBudgetAxisSourceTable,
            );
        },
        staleTime: STALE_TIME,
    });
};

const SecondaryBudgetAxisSourceTableProvider: React.FC<{
    children: ReactNode;
}> = ({ children }) => {
    const { data: sourceTable = null, isLoading } =
        useGetSecondaryBudgetAxisSourceTable();
    if (isLoading) {
        return null;
    }
    return (
        <SecondaryBudgetAxisSourceTableContext.Provider value={sourceTable}>
            {children}
        </SecondaryBudgetAxisSourceTableContext.Provider>
    );
};

export default SecondaryBudgetAxisSourceTableProvider;
